/**
 * Veilans search overlay helpers — popular-term chips fill the input
 * and trigger predictive search (Horizon requires InputEvent.inputType).
 */
(() => {
  const TERM_SELECTOR = '[data-veilans-search-term]';

  /**
   * @param {HTMLInputElement} input
   * @param {string} term
   */
  function fillAndSearch(input, term) {
    input.value = term;
    input.focus();
    input.dispatchEvent(
      new InputEvent('input', {
        bubbles: true,
        cancelable: true,
        inputType: 'insertText',
        data: term,
      })
    );
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest(TERM_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;

    const modal = button.closest('#search-modal, .veilans-search-modal');
    if (!modal) return;

    const input = modal.querySelector('.search-input, [ref="searchInput"]');
    if (!(input instanceof HTMLInputElement)) return;

    event.preventDefault();
    fillAndSearch(input, button.dataset.veilansSearchTerm || button.textContent.trim());
  });
})();
